import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useAppSelector } from "../../../../../_app";
import { customAlphabet } from "nanoid";
import { Notify, Utils } from "../../../../../utils";
import { EmployeeService, LeaveService } from "../../../../../_service";
import { CommonModal } from "../../../../../components";
import ExpenseGroupBlock from "./ExpenseGroupBlock";
import { ExpenseService } from "../../../../../_service/ExpenseService";
const nanoid = customAlphabet("0123456789", 10); // 10-digit numeric ID

const ExpenseApproval = () => {
  const [approvalGroupList, setApprovalGroupList] = useState([]);
  const [hasChanges, setHasChanges] = useState(false); // Track if any changes were made

  const [employeeList, setEmployeeList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);

  const [ allSubmitters, setAllSubmitters ] = useState([]);

  const [ selectedGroup, setSelectedGroup ] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const [employeesEligibleToBeSubmitters, setEmployeesEligibleToBeSubmitters] = useState([]);
  const [employeesEligibleToBeApprovers, setEmployeesEligibleToBeApprovers] = useState([]);

  const companyId = useAppSelector((state) => state.user.defaultCompnayId);


  const getEmployeeList = async () => {
    if (companyId) {
      try {
        setSending(() => true);
        const res = await EmployeeService._getEmployeeListByCompany(
          companyId,
          "1"
        );
        if (res.status === 200) {
          let data = res.data.data;

          let list = data.map((item: any) => {
            return {
              id: item?.id,
              name: item?.user?.name,
            };
          });
          setEmployeeList(() => list);
        }

        setSending(() => false);
      } catch (e: any) {
        Utils.showErrorMessage(e);
      }
    }
  };

  const getEmployeesEligibleToBeApprovers = async () => {
    if (companyId) {
      try {
        setSending(() => true);
        const res = await ExpenseService._getEmployeesEligibleToBeApprovers(companyId);
        if (res.status === 200) {
          let data = res.data.data;
          let list = data.map((item: any) => {
            return {
              id: item?.id,
              name: item?.user?.name,
            };
          });
          setEmployeesEligibleToBeApprovers(() => list);
        }
        setSending(() => false);
      } catch (e: any) {
        Utils.showErrorMessage(e);
      }
    }
  };

  const getEmployeesEligibleToBeSubmitters = async () => {
    if (companyId) {
      try {
        setSending(() => true);
        const res = await ExpenseService._getEmployeesEligibleToBeSubmitters(companyId);
        if (res.status === 200) {
          let data = res.data.data;
          let list = data.map((item: any) => {
            return {
              id: item?.id,
              name: item?.user?.name,
            };
          });
          setEmployeesEligibleToBeSubmitters(() => list);
        }
        setSending(() => false);
      } catch (e: any) {
        Utils.showErrorMessage(e);
      }
    }
  };

  useEffect(() => {
    // getEmployeeList();
    getApprovalGroupList();
    getEmployeesEligibleToBeApprovers();
    getEmployeesEligibleToBeSubmitters();
  }, [companyId]);

  console.log("The Company ID:", companyId);

  const handleAddGroup = () => {
    const newGroup: any = {
      customId: nanoid(),
      feature: "expense",
      approver_type: "single",
      approvers: [],
      submitters: [],
      company: companyId,
      isSaved: false,
    };

    setApprovalGroupList([...approvalGroupList, newGroup]);
    setHasChanges(true); // Mark as changed when adding a group
  };

  const handleSaveChanges = async () => {
    if (!hasChanges) {
      Notify("No changes to save.", 0);
      return;
    }

    if (approvalGroupList.length > 0) {
      try {
        setLoading(true);
        const res = await ExpenseService._createUpdateExpenseApprovalGroup(approvalGroupList);
        if (res.status >= 200 && res.status < 300) {
          getApprovalGroupList();
          Notify("Approval groups saved successfully.", 1);
          setHasChanges(false); // Reset changes flag after successful save
        }
      } catch (e: any) {
        Utils.showErrorMessage(e);
      } finally {
        setLoading(false);
      }
    } else {
      Notify("Please add at least one approval group.", 0);
    }
  };

  const deleteGroup = async (group: any) => {
    console.log("Deleting group:", group);
    setHasChanges(true); // Mark as changed when deleting a group

    if(group?.id){
      try {
        setLoading(true);
        const res = await ExpenseService._deleteExpenseApprovalGroup(group?.id);
        if (res.status >= 200 && res.status < 300) {
          // Successfully deleted the group
          setApprovalGroupList(approvalGroupList.filter((g) => g.customId !== group.customId));
        }
      } catch (e: any) {
        Utils.showErrorMessage(e);
      } finally {
        setLoading(false);
        setIsOpen(false);
        setSelectedGroup(null);
      }
    } else {
      // if the group is not saved, just remove it from the list
      setApprovalGroupList(approvalGroupList.filter((g) => g.customId !== group.customId));
      setIsOpen(false);
      setSelectedGroup(null);
    }
  };

  const getApprovalGroupList = async () => {
    if (companyId) {
      try {
        setLoading(true);
        const res = await ExpenseService._getExpenseApprovalGroups(companyId);
        if (res.status === 200) {
          let data = res.data.data?.map((item: any) => {
            return {
              ...item,
              customId: nanoid(),
            };
          });

          let submitters = data?.flatMap((group: any) => group?.submitters || []).map((submitter: any) => (submitter.id));
          let approvers = data?.flatMap((group: any) => group?.approvers || []).map((approver: any) => (approver.id));

          setAllSubmitters(submitters);

          console.log("Submitters:", submitters);
          console.log("Approvers:", approvers);
          setApprovalGroupList(data);
          setHasChanges(false); // Reset changes flag when loading fresh data
        }
        setLoading(false);
      } catch (e: any) {
        Utils.showErrorMessage(e);
        setLoading(false);
      }
    }
  };

  const updateAllSubmitters = (submitterId: any) => {
    if( !allSubmitters.includes(submitterId)) {
      setAllSubmitters([...allSubmitters, submitterId]);
    } else {
      setAllSubmitters(allSubmitters.filter((id) => id !== submitterId));
    }
  }

  console.log("Approval Group List:", approvalGroupList);

  console.log("All Submitters:", allSubmitters);

  console.log("Selected Group:", selectedGroup);

  return (
    <div>
      {/* <ButtonGroup>
        <FormattedMessage color='#10b981' onClick={handleSaveChanges}>
          Save Changes
        </FormattedMessage>
        <FormattedMessage color='#3396D3' onClick={handleAddGroup}>
          Add Group
        </FormattedMessage>
      </ButtonGroup> */}

      <StyledLargeButton 
        // disabled={!hasChanges}
        // $hasChanges={hasChanges}
      >
        <FormattedMessage 
        onClick={handleSaveChanges}>
          Save Changes
        </FormattedMessage>
      </StyledLargeButton>
      <StyledLargeButton >
        <FormattedMessage onClick={handleAddGroup} bgColor={"#3396D3"}>
          Add Group
        </FormattedMessage>
      </StyledLargeButton>

      {approvalGroupList?.map((group: any) => (
        <ExpenseGroupBlock
          key={group?.customId}
          group={group}
          employeesEligibleToBeApprovers={employeesEligibleToBeApprovers}
          employeesEligibleToBeSubmitters={employeesEligibleToBeSubmitters}
          setApprovalGroupList={setApprovalGroupList}
          approvalGroupList={approvalGroupList}
          approverType={group?.approver_type}
          companyId={companyId}
          isSaved={group?.isSaved || false}
          approversList={group?.approvers || []}
          submittersList={group?.submitters || []}
          allSubmitters={allSubmitters}
          selectedGroupId={selectedGroup?.customId}
          onAddApprover={(approver: any) => {
            setHasChanges(true); // Mark as changed
            const updatedGroup = {
              ...group,
              approvers: [...(group?.approvers || []), approver],
            };
            setApprovalGroupList(
              approvalGroupList?.map((g) =>
                g?.customId === group?.customId ? updatedGroup : g
              )
            );
          }}
          onAddSubmitter={(submitter: any) => {
            setHasChanges(true); // Mark as changed
            updateAllSubmitters(submitter?.id);
            const updatedGroup = {
              ...group,
              submitters: [...(group?.submitters || []), submitter],
            };
            setApprovalGroupList(
              approvalGroupList?.map((g) =>
                g?.customId === group?.customId ? updatedGroup : g
              )
            );
          }}
          onRemoveApprover={(approverId: number) => {
            setHasChanges(true); // Mark as changed
            const updatedGroup = {
              ...group,
              approvers: group?.approvers?.filter(
                (a: any) => a?.id !== approverId
              ),
            };
            setApprovalGroupList(
              approvalGroupList?.map((g) =>
                g?.customId === group?.customId ? updatedGroup : g
              )
            );
          }}
          onRemoveSubmitter={(submitterId: number) => {
            setHasChanges(true); // Mark as changed
            updateAllSubmitters(submitterId);
            const updatedGroup = {
              ...group,
              submitters: group?.submitters?.filter(
                (s: any) => s?.id !== submitterId
              ),
            };
            setApprovalGroupList(
              approvalGroupList?.map((g) =>
                g?.customId === group?.customId ? updatedGroup : g
              )
            );
          }}
          onRemoveGroup={() => {
            setSelectedGroup(group);
            setIsOpen(true);
          }}
          onClearApprovers={() => {
            setHasChanges(true); // Mark as changed
            const updatedGroup = {
              ...group,
              approvers: [],
            };
            setApprovalGroupList(
              approvalGroupList?.map((g) =>
                g?.customId === group?.customId ? updatedGroup : g
              )
            );
          }}
          onClearSubmitters={() => {
            setHasChanges(true); // Mark as changed
            updateAllSubmitters(null);
            const updatedGroup = {
              ...group,
              submitters: [],
            };
            setApprovalGroupList(
              approvalGroupList?.map((g) =>
                g?.customId === group?.customId ? updatedGroup : g
              )
            );
          }}
          onApproverTypeChange={(type: string) => {
            setHasChanges(true); // Mark as changed
            const updatedGroup = {
              ...group,
              approver_type: type,
            };
            setApprovalGroupList(
              approvalGroupList?.map((g) =>
                g?.customId === group?.customId ? updatedGroup : g
              )
            );
          }}
        />
      ))}

      {/* <LeaveGroupBlock employees={employees} /> */}
      <CommonModal
        handleClose={() => {
          setIsOpen(false);
          setSelectedGroup(null);
        }}
        open={isOpen}
        updateData={()=>deleteGroup(selectedGroup)}
        body={`Are you sure you want to delete this approval group?`}
        heading="Confirm Group Deletion"
        conformButtonText="Yes"
        cancelButtonText="No"
        onCancel={() => {
          setIsOpen(false);
          setSelectedGroup(null);
        }}
      />
    </div>
  );
};

export default ExpenseApproval;

const StyledLargeButton = styled.div<{ disabled?: boolean; $hasChanges?: boolean }>`
  display: flex;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 20px;
  width: 100%;
  background-color: ${props => props.disabled ? '#f5f5f5' : '#f0f0f0'};
  color: ${props => props.disabled ? '#999' : '#333'};
  padding: 10px;
  text-align: center;
  min-height: 5rem;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.2s ease;
  opacity: ${props => props.disabled ? 0.6 : 1};

  &:hover {
    /* background-color: ${props => props.disabled ? '#f5f5f5' : '#e0e0e0'}; */
  }
`;

// const FormattedMessage = styled.button<{ color?: string }>`
//   font-size: 0.875rem;
//   font-weight: 600;
//   width: 15%;
//   color: ${props => props.color || '#10b981'};
//   background-color: #ffffff;
//   border: 1px solid ${props => props.color || '#10b981'};
//   padding: 0.75rem 1.5rem;
//   border-radius: 6px;
//   margin: 0;
//   text-align: center;
//   letter-spacing: 0.025em;
//   cursor: pointer;
//   transition: all 0.15s ease-in-out;
//   box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
//   outline: none;

//   &:hover {
//     background-color: ${props => props.color || '#10b981'};
//     color: #ffffff;
//     box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
//     transform: translateY(-1px);
//   }

//   &:active {
//     transform: translateY(0);
//     box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
//   }

//   &:focus {
//     box-shadow: 0 0 0 3px ${props => props.color ? `${props.color}20` : '#10b98120'};
//   }

//   &:disabled {
//     opacity: 0.5;
//     cursor: not-allowed;
//     transform: none;
//   }
// `;
const FormattedMessage = styled.button<{ color?: string, bgColor?: string }>`
  font-size: 0.875rem;
  font-weight: 600;
  width: 15%;
  color: ${props => props.color || '#fff'};
  background-color: ${props => props.bgColor || '#10b981'};
  border: 1px solid ${props => props.color || '#10b981'};
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  margin: 0;
  text-align: center;
  letter-spacing: 0.025em;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  outline: none;

  &:hover {
    background-color: ${props => props.bgColor || '#10b981'};
    color: #ffffff;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    /* transform: translateY(-1px); */
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  &:focus {
    box-shadow: 0 0 0 3px ${props => props.color ? `${props.color}20` : '#10b98120'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
`;
